<script>
    import LandformSVG from "../report-sections/LandformSVG.svelte";

	export let dataLandformMapped;
    export let descriptionBelow = true;


	let cells = ['landform'];
	$: overrides = new Map([['dataLandformMapped', dataLandformMapped]]);
</script>

{#if !descriptionBelow}
    <p>
        The landform tree hierarchy below shows where the selected soil mapunit fits within the wider landscape
    </p>
{/if}

{#await dataLandformMapped}
{:then landformElements}
    {#if Array.isArray(landformElements)}
        <LandformSVG {landformElements} />
    {/if}
{/await}

{#if descriptionBelow}
    <p>
        The landform tree hierarchy above shows where the selected soil fits within the wider landscape
    </p>
{/if}

{#if !descriptionBelow}
    <div aria-hidden="true" style="padding-bottom: 2em"></div>
{/if}
